document.addEventListener("DOMContentLoaded", function () {

      
/* =====================================
   SAVE DELIVERY DETAILS TO SHOPIFY CART
   Date + Slot + Location + Personal Message
   ALL AS CART ATTRIBUTES
===================================== */

window.saveDeliveryDetailsToCart = function () {

    /* =====================================
       DELIVERY ELEMENTS
    ===================================== */

    const cityElement =
        document.getElementById("selected-city");

    const dateElement =
        document.getElementById("selected-delivery-date");

    const slotElement =
        document.getElementById("selected-delivery-slot");


    /* =====================================
       CITY
    ===================================== */

    const city =
        cityElement
            ? cityElement.textContent.trim()
            : (localStorage.getItem("selectedCity") || "");


    /* =====================================
       DELIVERY DATE
       Date already defaults to TODAY
    ===================================== */

    const deliveryDate =
        dateElement && dateElement.value
            ? dateElement.value
            : (
                document.getElementById(
                    "custom-delivery-date"
                )?.value || ""
            );


    /* =====================================
       DELIVERY SLOT
    ===================================== */

    const deliverySlot =
        slotElement && slotElement.value
            ? slotElement.value
            : "No slot selected";


    /* =====================================
       PERSONAL MESSAGE
    ===================================== */

    const personalMessageField =
        document.querySelector(
            '#gift-message, ' +
            '#personal-message, ' +
            '#personal_message, ' +
            'textarea[name="Personal Message"], ' +
            'textarea[name="personal_message"], ' +
            'textarea[placeholder="Write your message"]'
        );


    const personalMessage =
        personalMessageField &&
        personalMessageField.value.trim()
            ? personalMessageField.value.trim()
            : "No message from customer";


    /* =====================================
       DEBUG
    ===================================== */

    console.log(
        "Saving delivery details to cart:",
        {
            city: city,
            date: deliveryDate,
            slot: deliverySlot,
            personalMessage: personalMessage
        }
    );


    /* =====================================
       CART ATTRIBUTES
    ===================================== */

    const formData =
        new FormData();


    formData.append(
        "attributes[Delivery-Date]",
        deliveryDate
    );


    formData.append(
        "attributes[Delivery-Time]",
        deliverySlot
    );


    formData.append(
        "attributes[Delivery-Location]",
        city
    );


    formData.append(
        "attributes[Personal Message]",
        personalMessage
    );


    /* =====================================
       SAVE TO SHOPIFY CART
    ===================================== */

    return fetch(
        window.Shopify.routes.root + "cart/update.js",
        {
            method: "POST",
            body: formData
        }
    )

    .then(function (response) {

        if (!response.ok) {

            throw new Error(
                "Failed to save delivery details to cart."
            );

        }

        return response.json();

    })

    .then(function (cart) {

        console.log(
            "Delivery details saved successfully:",
            cart.attributes
        );

        return cart;

    })

    .catch(function (error) {

        console.error(
            "Delivery details could not be saved:",
            error
        );

        throw error;

    });

};

/* =====================================
   PERSONAL MESSAGE
   SAVE WHEN CUSTOMER FINISHES EDITING
===================================== */

const personalMessageField =
    document.getElementById("gift-message");

if (personalMessageField) {

    personalMessageField.addEventListener(
        "change",
        function () {

            console.log(
                "Personal Message changed:",
                personalMessageField.value
            );

            if (
                typeof window.saveDeliveryDetailsToCart ===
                "function"
            ) {

                window.saveDeliveryDetailsToCart();

            }

        }
    );


    /*
     * Also save when customer leaves
     * the Personal Message field.
     *
     * This helps when the customer types
     * a message and immediately clicks
     * Add to Cart / Buy It Now.
     */

    personalMessageField.addEventListener(
        "blur",
        function () {

            if (
                typeof window.saveDeliveryDetailsToCart ===
                "function"
            ) {

                window.saveDeliveryDetailsToCart();

            }

        }
    );

}
    /* =====================================
       CITY CHANGE (Dropdown)
    ===================================== */

    // const city = document.getElementById("delivery-city");
    // const groups = document.querySelectorAll(".slot-group");

    // if (city && groups.length) {

    //     function updateSlots() {

    //         groups.forEach(function (group) {

    //             if (group.dataset.city === city.value) {
    //                 group.style.display = "block";
    //             } else {
    //                 group.style.display = "none";
    //             }

    //         });

    //     }

    //     city.addEventListener("change", updateSlots);

    //     updateSlots();

    // }

    /* =====================================
   CITY CHANGE (HEADER DROPDOWN)
===================================== */

/* =====================================
   HEADER CITY + DELIVERY LOCATION
===================================== */

const headerCity = document.getElementById("city-selector");
const selectedCityElement = document.getElementById("selected-city");
const selectedAddressElement = document.getElementById("selected-address");

if (headerCity) {

    function updateDeliveryCity(cityName) {

        /* Update header dropdown */
        headerCity.value = cityName;

        /* Update delivery location card */
        if (selectedCityElement) {
            selectedCityElement.textContent = cityName;
        }

        if (selectedAddressElement) {
            selectedAddressElement.textContent = cityName + ", India";
        }

        /* Save city */
        localStorage.setItem("selectedCity", cityName);

        console.log("Delivery city updated:", cityName);
    }


    /* ---------------------------------
       LOAD SAVED CITY
    --------------------------------- */

    const savedCity = localStorage.getItem("selectedCity");

    if (savedCity) {
        updateDeliveryCity(savedCity);
    } else {
        updateDeliveryCity(headerCity.value);
    }


    /* ---------------------------------
       WHEN HEADER DROPDOWN CHANGES
    --------------------------------- */

    headerCity.addEventListener("change", function () {

    const newCity = this.value;

    updateDeliveryCity(newCity);

    /* Save city to Shopify cart */
    if (
        typeof window.saveDeliveryDetailsToCart ===
        "function"
    ) {
        window.saveDeliveryDetailsToCart();
    }

});

}

   /* =====================================
   DELIVERY DATE (Commented)
===================================== */

// const dateCards = document.querySelectorAll(".date-card");
// const dateInput = document.getElementById("custom-delivery-date");
// const moreBtn = document.querySelector(".more-dates-btn");
// const moreCard = document.getElementById("more-date-card");
// ...

/* =====================================
   DELIVERY DATE
===================================== */

const todayCard = document.getElementById("today-card");
const tomorrowCard = document.getElementById("tomorrow-card");
const thirdDateCard = document.getElementById("third-date-card");
const moreCard = document.getElementById("more-date-card");

const dateInput = document.getElementById("custom-delivery-date");

/*
 * Hidden Shopify line-item property
 * This input is now inside the buy-button
 * Shopify product form.
 */
const selectedDeliveryDateInput =
    document.getElementById("selected-delivery-date");

const dateCards =
    document.querySelectorAll(".date-card");


/* =====================================
   SUBSCRIPTION CHECK
===================================== */

const subscriptionData =
    document.getElementById("product-subscription-data");

const subscriptionMessage =
    document.getElementById("subscription-message");

const deliveryDateSection =
    document.querySelector(".delivery-date");


const isSubscriptionProduct =
    subscriptionData &&
    subscriptionData.dataset.subscription === "true";


/* =====================================
   SUBSCRIPTION PRODUCT
===================================== */

if (isSubscriptionProduct) {

    if (deliveryDateSection) {
        deliveryDateSection.style.display = "none";
    }

    if (subscriptionMessage) {
        subscriptionMessage.style.display = "block";
    }

}


/* =====================================
   FORMAT DATE CARD
===================================== */

function updateDateCard(card, date, label) {

    if (!card || !date) {
        return;
    }

    const day =
        date.toLocaleDateString("en-US", {
            weekday: "short"
        }).toUpperCase();

    const number =
        date.getDate();

    const month =
        date.toLocaleDateString("en-US", {
            month: "short"
        }).toUpperCase();

    const dayElement =
        card.querySelector(".day");

    const numberElement =
        card.querySelector(".number");

    const monthElement =
        card.querySelector(".month");


    if (dayElement) {
        dayElement.textContent =
            label || day;
    }

    if (numberElement) {
        numberElement.textContent =
            number;
    }

    if (monthElement) {
        monthElement.textContent =
            month;
    }

}


/* =====================================
   TODAY
===================================== */

const today = new Date();

today.setHours(
    0,
    0,
    0,
    0
);


/* =====================================
   TOMORROW
===================================== */

const tomorrow =
    new Date(today);

tomorrow.setDate(
    tomorrow.getDate() + 1
);


/* =====================================
   THIRD DATE
===================================== */

const thirdDate =
    new Date(today);

thirdDate.setDate(
    thirdDate.getDate() + 2
);


/* =====================================
   SHOW DATES
===================================== */

updateDateCard(
    todayCard,
    today,
    "TODAY"
);

updateDateCard(
    tomorrowCard,
    tomorrow,
    "TOMORROW"
);

updateDateCard(
    thirdDateCard,
    thirdDate
);


/* =====================================
   SET MINIMUM DATE
===================================== */

if (dateInput) {

    const year =
        today.getFullYear();

    const month =
        String(
            today.getMonth() + 1
        ).padStart(2, "0");

    const day =
        String(
            today.getDate()
        ).padStart(2, "0");

    dateInput.min =
        `${year}-${month}-${day}`;
}


/* =====================================
   DEFAULT DELIVERY DATE = TODAY
===================================== */

if (todayCard) {

    todayCard.classList.add("active");

}


/* =====================================
   SET DEFAULT CALENDAR DATE
===================================== */

if (dateInput) {

    const year =
        today.getFullYear();

    const month =
        String(
            today.getMonth() + 1
        ).padStart(2, "0");

    const day =
        String(
            today.getDate()
        ).padStart(2, "0");

    dateInput.value =
        `${year}-${month}-${day}`;

}

/* =====================================
   FUNCTION
   SET HIDDEN DELIVERY DATE
===================================== */

function setSelectedDeliveryDate(date) {

    if (!date) {
        console.warn(
            "Delivery date not provided."
        );

        return;
    }


    if (!selectedDeliveryDateInput) {

        console.error(
            "Hidden delivery date input #selected-delivery-date was not found."
        );

        return;
    }


    const year =
        date.getFullYear();

    const month =
        String(
            date.getMonth() + 1
        ).padStart(2, "0");

    const day =
        String(
            date.getDate()
        ).padStart(2, "0");


    const formattedDate =
        `${year}-${month}-${day}`;


    /* =====================================
       SAVE TO SHOPIFY HIDDEN INPUT
    ===================================== */

    selectedDeliveryDateInput.value =
        formattedDate;


    console.log(
        "Selected Delivery Date:",
        formattedDate
    );


    /* =====================================
       SAVE TO SHOPIFY CART
    ===================================== */

    if (
        typeof window.saveDeliveryDetailsToCart ===
        "function"
    ) {

        window.saveDeliveryDetailsToCart();

    }

}


/* =====================================
   INITIALIZE DEFAULT DELIVERY DATE
===================================== */

setSelectedDeliveryDate(today);


/* =====================================
   DATE CARD CLICK
===================================== */

dateCards.forEach(function(card) {

    card.addEventListener(
        "click",
        function() {

            if (isSubscriptionProduct) {
                return;
            }


            /* ==============================
               MORE DATE → OPEN CALENDAR
            ============================== */

            if (
                card.id ===
                "more-date-card"
            ) {

                if (dateInput) {

                    if (
                        typeof dateInput.showPicker ===
                        "function"
                    ) {

                        dateInput.showPicker();

                    } else {

                        dateInput.click();

                    }

                }

                return;
            }


            /* ==============================
               REMOVE ACTIVE
            ============================== */

            dateCards.forEach(
                function(item) {

                    item.classList.remove(
                        "active"
                    );

                }
            );


            /* ==============================
               ADD ACTIVE
            ============================== */

            card.classList.add(
                "active"
            );


            /* ==============================
               SELECT DATE
            ============================== */

            let selectedDate = null;


            if (
                card.id ===
                "today-card"
            ) {

                selectedDate =
                    new Date(today);

            }

            else if (
                card.id ===
                "tomorrow-card"
            ) {

                selectedDate =
                    new Date(tomorrow);

            }

            else if (
                card.id ===
                "third-date-card"
            ) {

                selectedDate =
                    new Date(thirdDate);

            }


            /* ==============================
               SET CALENDAR INPUT
            ============================== */

            if (
                selectedDate &&
                dateInput
            ) {

                const year =
                    selectedDate.getFullYear();

                const month =
                    String(
                        selectedDate.getMonth() + 1
                    ).padStart(2, "0");

                const day =
                    String(
                        selectedDate.getDate()
                    ).padStart(2, "0");


                dateInput.value =
                    `${year}-${month}-${day}`;

            }


            /* ==============================
               SET SHOPIFY DATE
            ============================== */

            if (selectedDate) {

                setSelectedDeliveryDate(
                    selectedDate
                );

            }


            /* ==============================
               UPDATE DELIVERY SLOT DATE
            ============================== */

            if (
                selectedDate &&
                typeof setDeliverySlotDate ===
                "function"
            ) {

                setDeliverySlotDate(
                    selectedDate
                );

            }

        }
    );

});


/* =====================================
   CUSTOM DATE SELECTED
===================================== */

if (dateInput) {

    dateInput.addEventListener(
        "change",
        function() {

            if (isSubscriptionProduct) {
                return;
            }


            if (!this.value) {
                return;
            }


            const selected =
                new Date(
                    this.value +
                    "T00:00:00"
                );


            /* ==============================
               SET SHOPIFY DATE
            ============================== */

            setSelectedDeliveryDate(
                selected
            );


            /* ==============================
               REMOVE ACTIVE
            ============================== */

            dateCards.forEach(
                function(card) {

                    card.classList.remove(
                        "active"
                    );

                }
            );


            /* ==============================
               TODAY
            ============================== */

            if (
                selected.getTime() ===
                today.getTime()
            ) {

                todayCard.classList.add(
                    "active"
                );

            }


            /* ==============================
               TOMORROW
            ============================== */

            else if (
                selected.getTime() ===
                tomorrow.getTime()
            ) {

                tomorrowCard.classList.add(
                    "active"
                );

            }


            /* ==============================
               DAY AFTER TOMORROW
            ============================== */

            else if (
                selected.getTime() ===
                thirdDate.getTime()
            ) {

                thirdDateCard.classList.add(
                    "active"
                );

            }


            /* ==============================
               CUSTOM DATE
            ============================== */

            else if (moreCard) {

                moreCard.classList.add(
                    "active"
                );

                updateDateCard(
                    moreCard,
                    selected
                );

            }


            /* ==============================
               UPDATE DELIVERY SLOT DATE
            ============================== */

            if (
                typeof setDeliverySlotDate ===
                "function"
            ) {

                setDeliverySlotDate(
                    selected
                );

            }

        }
    );

}

  /* =====================================
   DELIVERY SLOT
===================================== */

const slots = document.querySelectorAll(".slot");


/* =====================================
   SUBSCRIPTION CHECK
===================================== */

const slotSubscriptionData =
    document.getElementById("product-subscription-data");

const slotSubscriptionMessage =
    document.getElementById("subscription-message");

const deliverySlotSection =
    document.querySelector(".delivery-slot");


const slotIsSubscriptionProduct =
    slotSubscriptionData &&
    slotSubscriptionData.dataset.subscription === "true";


/* =====================================
   SUBSCRIPTION PRODUCT
===================================== */

if (slotIsSubscriptionProduct) {

    if (deliverySlotSection) {
        deliverySlotSection.style.display = "none";
    }

    if (slotSubscriptionMessage) {
        slotSubscriptionMessage.style.display = "block";
    }

}


/* =====================================
   SLOT CLOSING TIMES
===================================== */

const slotClosingTimes = {

    "8AM-12PM": "10:00",

    "12PM-3PM": "14:00",

    "2PM-6PM": "16:00",

    "3PM-8PM": "18:30"

};


/* =====================================
   SELECTED DELIVERY DATE
===================================== */

let selectedDeliveryDate = new Date();

selectedDeliveryDate.setHours(
    0,
    0,
    0,
    0
);


/* =====================================
   UPDATE SLOT STATUS
===================================== */

function updateSlotStatus() {

    /*
     * Subscription product
     * does not use delivery slots.
     */

    if (slotIsSubscriptionProduct) {

        slots.forEach(function(slot) {

            slot.classList.remove("disabled");
            slot.classList.remove("time-closed");
            slot.classList.remove("active");

        });

        return;
    }


    /* =====================================
       TODAY
    ===================================== */

    const today = new Date();

    today.setHours(
        0,
        0,
        0,
        0
    );


    const selectedDate =
        new Date(selectedDeliveryDate);

    selectedDate.setHours(
        0,
        0,
        0,
        0
    );


    /* =====================================
       FUTURE DATE
    ===================================== */

    if (selectedDate.getTime() > today.getTime()) {

        slots.forEach(function(slot) {

            slot.classList.remove("time-closed");


            if (
                slot.classList.contains("city-disabled")
            ) {

                slot.classList.add("disabled");

            } else {

                slot.classList.remove("disabled");

            }

        });

        return;
    }


    /* =====================================
       TODAY → CHECK CURRENT TIME
    ===================================== */

    const now = new Date();

    const currentTime =
        now.getHours() * 60 +
        now.getMinutes();


    slots.forEach(function(slot) {

        const slotName =
            slot.dataset.slot;

        const closeTime =
            slotClosingTimes[slotName];


        if (!closeTime) {
            return;
        }


        const parts =
            closeTime.split(":");


        const closeHours =
            parseInt(parts[0], 10);

        const closeMinutes =
            parseInt(parts[1], 10);


        const slotCloseTime =
            closeHours * 60 +
            closeMinutes;


        /* =====================================
           TIME CLOSED
        ===================================== */

        if (currentTime >= slotCloseTime) {

            slot.classList.add("time-closed");

        } else {

            slot.classList.remove("time-closed");

        }


        /* =====================================
           FINAL DISABLED STATE
        ===================================== */

        if (
            slot.classList.contains("city-disabled") ||
            slot.classList.contains("time-closed")
        ) {

            slot.classList.add("disabled");

            slot.classList.remove("active");

        } else {

            slot.classList.remove("disabled");

        }

    });

}


/* =====================================
   SET DELIVERY DATE
===================================== */

function setDeliverySlotDate(date) {

    if (!date) {
        return;
    }


    selectedDeliveryDate =
        new Date(date);

    selectedDeliveryDate.setHours(
        0,
        0,
        0,
        0
    );


    console.log(
        "Selected delivery date:",
        selectedDeliveryDate
    );


    updateSlotStatus();

}


/* =====================================
   SLOT CLICK
===================================== */

slots.forEach(function(slot) {

    slot.addEventListener("click", function() {


        /* =====================================
           DON'T ALLOW DISABLED SLOT
        ===================================== */

        if (
            this.classList.contains("disabled")
        ) {

            return;

        }


        /* =====================================
           REMOVE ACTIVE FROM ALL SLOTS
        ===================================== */

        slots.forEach(function(item) {

            item.classList.remove("active");

        });


        /* =====================================
           ADD ACTIVE TO SELECTED SLOT
        ===================================== */

        this.classList.add("active");


        /* =====================================
           GET SELECTED SLOT
        ===================================== */

        const selectedSlot =
            this.dataset.slot;


        console.log(
            "Selected Delivery Slot:",
            selectedSlot
        );


        /* =====================================
           SAVE SLOT TO SHOPIFY FORM
        ===================================== */

        const selectedDeliverySlotInput =
            document.getElementById(
                "selected-delivery-slot"
            );


        if (selectedDeliverySlotInput) {

            selectedDeliverySlotInput.value =
                selectedSlot;
            /* Save delivery slot to Shopify cart */
if (
    typeof window.saveDeliveryDetailsToCart ===
    "function"
) {
    window.saveDeliveryDetailsToCart();
}

            console.log(
                "Delivery Slot saved:",
                selectedDeliverySlotInput.value
            );

        } else {

            console.warn(
                "Delivery slot hidden input not found."
            );

        }

    });

});


/* =====================================
   INITIAL CHECK
===================================== */

updateSlotStatus();


/* =====================================
   CHECK EVERY MINUTE
===================================== */

setInterval(function() {

    updateSlotStatus();

}, 60000);

   /* =====================================
CHANGE LOCATION POPUP
===================================== */

const popup = document.getElementById("location-popup");
const changeLocationBtn = document.getElementById("change-location-btn");
const closePopup = document.querySelector(".close-popup");

const cityOptions = document.querySelectorAll(".city-option");

const selectedCity = document.getElementById("selected-city");
const selectedAddress = document.getElementById("selected-address");

// All Slot Cards
const allSlots = document.querySelectorAll(".slot");

// Slot availability by city
const slotAvailability = {

Bangalore: [
    "8AM-12PM",
    "12PM-3PM",
    "2PM-6PM",
    "3PM-8PM"
],

Hyderabad: [
    "8AM-12PM",
    "12PM-3PM",
    "3PM-8PM"
],

Delhi: [
    "12PM-3PM",
    "2PM-6PM",
    "3PM-8PM"
]


};
const cityPincodes = {

Delhi: [
    "201301","201303","201304","201305","201307","201309","201313","201318",
    "121003","121006","121007","121008","121009","121010","121012","121013",
    "110030","110037","110047","110057","110062","110067","110068","110070",
    "110074","110001","110002","110003","110004","110005","110006","110008",
    "110010","110011","110012","110013","110014","110017","110021","110022",
    "110055","110060","110066","110069","110080","110090","110025","110031",
    "110051","110065","110076","110091","110092","110096","201009","201011",
    "201012","201014","201019","110016","110019","110020","110023","110024",
    "110029","110048","110049","110026","122001"
],

Bangalore: [
    "560001","560002","560003","560004","560005","560006","560008","560009",
    "560010","560011","560012","560013","560014","560015","560016","560017",
    "560019","560020","560021","560022","560023","560024","560025","560026",
    "560027","560029","560030","560032","560033","560034","560035","560036",
    "560037","560038","560039","560040","560041","560042","560043","560045",
    "560046","560047","560048","560049","560050","560051","560052","560053",
    "560054","560055","560056","560057","560058","560059","560061","560062",
    "560064","560065","560066","560067","560068","560069","560070","560071",
    "560072","560075","560076","560077","560078","560079","560080","560082",
    "560083","560084","560085","560086","560087","560091","560092","560093",
    "560094","560095","560096","560097","560098","560099","560100","560102",
    "560103","560104","562130","562149"
],

Hyderabad: [
    "500001","500002","500003","500004","500005","500006","500007","500008",
    "500009","500010","500011","500012","500013","500014","500015","500016",
    "500017","500018","500020","500022","500023","500024","500025","500026",
    "500027","500028","500029","500030","500031","500032","500033","500034",
    "500035","500036","500038","500039","500040","500041","500043","500044",
    "500045","500046","500047","500048","500049","500050","500051","500052",
    "500053","500057","500058","500059","500060","500061","500062","500063",
    "500064","500065","500066","500067","500068","500069","500070","500071",
    "500072","500073","500074","500075","500076","500077","500079","500080",
    "500081","500082","500084","500085","500086","500089","500090","500091",
    "500094","500095","500096","500097","500098","500100","500102","500107",
    "500110","500111","500112","500118","501101","501201","501218","501301",
    "501359","501401","501503","502032","508126","509228"
]


};

// Popup Open
if(changeLocationBtn){

changeLocationBtn.addEventListener("click",function(){

    popup.classList.add("active");

});


}

// Popup Close
if(closePopup){

closePopup.addEventListener("click",function(){

    popup.classList.remove("active");

});


}

// City Selection
cityOptions.forEach(function(option){

option.addEventListener("click",function(){

    const city=this.textContent.trim();

    selectedCity.textContent=city;
    selectedAddress.textContent=city+", India";

    popup.classList.remove("active");

    // Remove previous active slot
    allSlots.forEach(function(slot){

        slot.classList.remove("active");

    });

    // Enable / Disable Slots
  allSlots.forEach(function(slot) {

const time = slot.dataset.slot;

if (
    slotAvailability[city] &&
    slotAvailability[city].includes(time)
) {

    slot.classList.remove("disabled");

} else {

    slot.classList.add("disabled");
    slot.classList.remove("active");

}


});
 checkSlotClosingTime();

    /* Save city to Shopify cart */
    if (
        typeof window.saveDeliveryDetailsToCart ===
        "function"
    ) {
        window.saveDeliveryDetailsToCart();
    }

});

});
/* =====================================
CHECK PINCODE
===================================== */

const checkBtn = document.getElementById("check-pincode");
const pinInput = document.getElementById("delivery-pincode");
const status = document.getElementById("delivery-status");


if(checkBtn && pinInput && status){

checkBtn.addEventListener("click", function(){

    const pin = pinInput.value.trim();

    const city = selectedCity.textContent.trim();

    if(pin.length !== 6){

        status.innerHTML = "❌ Please enter a valid 6-digit PIN.";
        status.style.color = "#d93025";
        return;

    }

    if(cityPincodes[city] && cityPincodes[city].includes(pin)){

        status.innerHTML = "✅ Delivery Available";
        status.style.color = "#000";

    }else{

        status.innerHTML = "❌ Delivery Not Available";
        status.style.color = "#d93025";

    }

});

/* =====================================
   PINCODE INPUT ENTER KEY EVENT
===================================== */
pinInput.addEventListener("keydown", function(event){
    if (event.key === "Enter") {
        event.preventDefault(); // Prevents default form submission
        checkBtn.click();       // Simulates clicking the "Check" button
    }
});


}
});


/* =====================================
   SUBSCRIPTION PRODUCT CHECK
===================================== */

document.addEventListener("DOMContentLoaded", function () {

    const subscriptionData =
        document.getElementById("product-subscription-data");

    const deliveryDate =
        document.querySelector(".delivery-date");

    const deliverySlot =
        document.querySelector(".delivery-slot");

    const subscriptionMessage =
        document.getElementById("subscription-message");


    /* =====================================
       CHECK IF PRODUCT IS SUBSCRIPTION
    ===================================== */

    if (!subscriptionData) {
        console.log("Subscription data not found");
        return;
    }

    const isSubscription =
        subscriptionData.dataset.subscription === "true";


    console.log("Subscription product:", isSubscription);


    /* =====================================
       SUBSCRIPTION PRODUCT
    ===================================== */

    if (isSubscription) {

        if (deliveryDate) {
            deliveryDate.style.display = "none";
        }

        if (deliverySlot) {
            deliverySlot.style.display = "none";
        }

        if (subscriptionMessage) {
            subscriptionMessage.style.display = "block";
        }

    }


    /* =====================================
       NORMAL PRODUCT
    ===================================== */

    else {

        if (deliveryDate) {
            deliveryDate.style.display = "";
        }

        if (deliverySlot) {
            deliverySlot.style.display = "";
        }

        if (subscriptionMessage) {
            subscriptionMessage.style.display = "none";
        }

    }

});